import { NavLink } from "react-router-dom";

const Sidebar = () => {
  return (
    <div style={styles.sidebar}>
      <NavLink
        to="/admin"
        end
        style={({ isActive }) => ({
          ...styles.link,
          color: isActive ? "#fff" : "#cbd5e1",
          fontWeight: isActive ? "bold" : "normal",
        })}
      >
        Dashboard
      </NavLink>

      <NavLink
        to="/admin/leads"
        style={({ isActive }) => ({
          ...styles.link,
          color: isActive ? "#fff" : "#cbd5e1",
          fontWeight: isActive ? "bold" : "normal",
        })}
      >
        Leads
      </NavLink>

      {/* <NavLink
        to="/admin/settings"
        style={({ isActive }) => ({
          ...styles.link,
          color: isActive ? "#fff" : "#cbd5e1",
          fontWeight: isActive ? "bold" : "normal",
        })}
      >
        Settings
      </NavLink> */}
    </div>
  );
};

const styles = {
  sidebar: {
    width: "150px",
    height: "calc(100vh - 56px)",
    background: "#1e293b",
    padding: "20px",
    position: "fixed",
    left: 0,
    top: "56px",
    overflowY: "auto",

  },
  logo: {
    marginBottom: "30px",
    fontWeight: "bold",
    color: "#fff",
  },
  link: {
    display: "block",
    textDecoration: "none",
    marginBottom: "15px",
  },
};

export default Sidebar;
